// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"942":"f8cfd996bf9d8726","3833":"a442b33e13e90255"}[chunkId] + ".css";
};